quick dropdown

<script>
import * as _ from 'lodash'
export default {
  model: {
    event: 'update',
  },
  props: {
    questionId: { type: Number, required: true },
    questionTitle: { type: String, required: true },
    questionOptions: { type: Array, required: true },
    questionType: { type: String, required: true },
    selected: { type: null, required: true },
    isdisabled: { type: Boolean, required: false },
    // eslint-disable-next-line vue/require-default-prop
    defaultValue: { type: String, required: false },
  },
  data() {
    return {
      ans: this.selected ? _.cloneDeep(this.selected) : '',
      items: this.questionOptions,
      questionOptionsArray: [],
    }
  },

  computed: {
    disableItems() {
      var array = this.$store.state.profileQuestions.questionnaire
      var question = this.$store.state.profileQuestions.questionnaire.find(
        (x) => x.question_id === this.questionId
      )
      if (question.dependent_question_id) {
        if (
          array.find((x) => x.question_id === question.dependent_question_id)
            .answers
        ) {
          return (
            array.find((x) => x.question_id === question.dependent_question_id)
              .answers?.key === 1
          )
        } else return true
      } else return false
    },
  },
  watch: {
    selected(newValue) {
      if (_.isEmpty(newValue)) {
        this.ans = []
      }
    },
    isdisabled(newValue) {
      if (_.isEmpty(newValue)) {
        this.ans = []
      }
    },

    ans(newValue) {
      if (newValue) {
        this.$emit(
          'update',
          this.questionOptionsArray.find((x) => x.key === newValue)
        )
      }
    },
    deep: true,
  },
  created() {
    if (this.selected === '') this.selected = 'null'
    this.questionOptions.unshift({ key: 'null', value: this.defaultValue })
    this.questionOptionsArray = this.questionOptions

    var index = this.questionOptionsArray.findIndex(
      (x) => x.key === this.ans.key
    )
    if (index === -1) this.ans = { key: 'null', value: this.defaultValue }
  },
}
</script>

<template id="dropdownwrapp">
  <div :class="$style.dropdownWrapp">
    <h3 :class="$style.question">{{ questionTitle }}</h3>
    <v-select
      v-model="ans"
      :disabled="disableItems"
      :items="questionOptionsArray"
      outlined
      hide-details="auto"
      item-text="value"
      item-value="key"
      class="mt-2"
      :value="ans"
      :class="$style.selectlist"
    ></v-select>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.btnClass {
  width: 240px;
  padding: 26px !important;
  font-size: 18px !important;
  font-weight: 600;
  color: #fff !important;
  text-transform: inherit;
  letter-spacing: inherit;
  background: #0476d9 !important;
  border: none;
  border-radius: 30px;
}
.selectlist {
  max-width: 340px;
}
.question {
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  color: #454648;
}
.questionOptionList {
  padding: 0 !important;
  margin: 0;
  list-style: none;
}
.questionOptionList li {
  float: left;
  margin-right: 10px;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  color: #09101d;
}
.questionOptionList li:last-child {
  margin-right: 0;
}
@media screen and (max-width: 479px) {
  .questionOptionList {
    display: flex;
    margin-left: 0;
  }
  .questionOptionList li {
    flex: 50%;
  }
}
</style>

<style scoped>
.v-radio.v-item--active {
  display: inline-block;
  width: 120px;
  padding: 12px;
  text-align: center;
  background: #0476d9;
  border: 2px solid #0476d9 !important;
  border-radius: 5px;
}
.v-radio {
  display: inline-block;
  width: 120px;
  padding: 12px;
  text-align: center;
  background: #fff;
  border: 2px solid #0476d9 !important;
  border-radius: 5px;
}

/deep/ .v-input--selection-controls__input .v-icon {
  display: none !important;
}
/deep/ .v-input--selection-controls__input {
  width: 0 !important;
  height: 0 !important;
}
/deep/ .v-input .v-label {
  position: relative !important;
  right: auto;
  left: -6px !important;
  font-weight: 600;
  color: #0476d9 !important;
}
/deep/ .v-radio.v-item--active .v-label {
  color: #fff !important;
}
/deep/
  .v-input--selection-controls__input:hover
  .v-input--selection-controls__ripple::before {
  background: inherit !important;
  -webkit-transition: none;
  transition: none;
  -webkit-transform: scale(1.2);
  transform: scale(1.2);
}

/deep/ .v-select__selections {
  line-height: 20px;
}

@media screen and (max-width: 479px) {
  .v-radio.v-item--active,
  .v-radio {
    width: 100%;
  }
}
</style>
